import { Reveal, Overline } from "../Reveal";

const MATERIALS = [
  {
    n: "I.",
    t: "Selected Leathers",
    d: "Top-quality Italian pelletteria, chosen hide-by-hide for hand, depth of colour and natural patina. The leather is the protagonist of every pair.",
  },
  {
    n: "II.",
    t: "100% Made in Italy",
    d: "Designed, cut, lasted and finished entirely in Italy by specialised artisans. No outsourced steps. No exceptions.",
  },
  {
    n: "III.",
    t: "Comfort",
    d: "A comfortable ergonomic insole, shaped to support the foot at every step.",
  },
  {
    n: "IV.",
    t: "Agile Production",
    d: "As a young house, we handle both large seasonal orders and smaller bespoke runs — capsules, store exclusives and gifting editions.",
  },
];

export default function Slide06Materials() {
  return (
    <section className="slide bg-[var(--ais-cream)]" data-testid="slide-06">
      <div className="min-h-screen flex items-center px-6 md:px-16 lg:px-24 py-24">
        <div className="w-full max-w-6xl mx-auto">
          <Reveal>
            <Overline>06 — Materials & Craft</Overline>
          </Reveal>
          <Reveal delay={1}>
            <div className="hairline w-16 my-8" />
          </Reveal>
          <Reveal delay={2}>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.75rem] text-[var(--ais-espresso)] leading-[1.05] tracking-[-0.01em] font-light max-w-3xl">
              Selected leathers.
              <br />
              <em className="italic">Italian</em> hands.
            </h2>
          </Reveal>

          <div className="mt-14 md:mt-16 grid grid-cols-1 md:grid-cols-4">
            {MATERIALS.map((m, i) => (
              <Reveal key={m.n} delay={3 + i}>
                <div
                  className={`p-6 md:p-8 h-full ${
                    i !== 0 ? "md:border-l border-[var(--ais-gold-soft)]" : ""
                  }`}
                >
                  <div className="font-serif italic text-2xl text-[var(--ais-gold)]">
                    {m.n}
                  </div>
                  <h3 className="mt-5 font-serif text-2xl md:text-[1.6rem] text-[var(--ais-espresso)] font-light leading-tight">
                    {m.t}
                  </h3>
                  <p className="mt-4 font-sans text-sm text-[var(--ais-text)] leading-[1.8] font-light">
                    {m.d}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
